import { apiClient } from './apiClient';
import type { UserPermissions, RecordAccess } from '../auth/permissions.types';

export const permissionsApi = {
  getMyPermissions: async (): Promise<UserPermissions> => {
    const response = await apiClient.get<UserPermissions>('/me/permissions');
    return response.data;
  },

  getAppraisalAccess: async (appraisalId: string): Promise<RecordAccess> => {
    const response = await apiClient.get<RecordAccess>(`/appraisals/${appraisalId}/my-access`);
    return response.data;
  },

  getJobEndAccess: async (jobEndId: string): Promise<RecordAccess> => {
    const response = await apiClient.get<RecordAccess>(`/job-ends/${jobEndId}/my-access`);
    return response.data;
  },
};

export default permissionsApi;
